import React, { PureComponent } from 'react'
import { array, number } from 'prop-types'

import './McGame.css'
import { Ranking } from './Ranking/Ranking'

export class McGameTabResults extends PureComponent {
    static propTypes = {
        currentSeason: array.isRequired,
        lastSeason: array,
        currentSeasonNumber: number.isRequired
    }

    renderRanking = (ranking, currentSeasonNumber, index) => (
        <div className={`McGame-Table__wrapper McGame-Table__wrapper--${!index ? 'first' : 'last'}`}>
            <div className="McGame-Table__title">Ranking SEASON {currentSeasonNumber}:</div>
            <Ranking ranking={ranking} type={index ? 'primary' : 'secondary'} />
        </div>
    )

    render() {
        const { currentSeason, lastSeason, currentSeasonNumber } = this.props
        return (
            <div className="McGame-Tab-Results">
                {!!(lastSeason || []).length && this.renderRanking(lastSeason, currentSeasonNumber - 1, 1)}
                {!!(currentSeason || []).length && this.renderRanking(currentSeason, currentSeasonNumber, 0)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/Game/McGameTabResults.js